import { render, staticRenderFns } from "./caseExpirationReminder.vue?vue&type=template&id=25c62a46&scoped=true"
import script from "./caseExpirationReminder.vue?vue&type=script&lang=js"
export * from "./caseExpirationReminder.vue?vue&type=script&lang=js"
import style0 from "./caseExpirationReminder.vue?vue&type=style&index=0&id=25c62a46&prod&lang=css"
import style1 from "./caseExpirationReminder.vue?vue&type=style&index=1&id=25c62a46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c62a46",
  null
  
)

export default component.exports